import { render, staticRenderFns } from "./bookDetail.vue?vue&type=template&id=3af07c4c&scoped=true&"
import script from "./bookDetail.vue?vue&type=script&lang=js&"
export * from "./bookDetail.vue?vue&type=script&lang=js&"
import style0 from "./bookDetail.vue?vue&type=style&index=0&id=3af07c4c&prod&lang=scss&"
import style1 from "./bookDetail.vue?vue&type=style&index=1&id=3af07c4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af07c4c",
  null
  
)

export default component.exports